/**
 * External dependencies
 */
import React from "react";
import { connect } from "react-redux";
import { Box } from "@towersystems/towersystems-design-system";
import DocumentHead from "data/document-head";

/**
 * Internal dependences
 */
import Main from "components/main";
import Grid from "modules/dashboard/grid";
import { updateLayoutItems } from "state/dashboard/actions";
import EditDashboardPopover from "blocks/edit-dashboard-popover";
import DashboardActions from "modules/dashboard/dashboard-actions";
import DashboardFilters from "modules/dashboard/dashboard-filters";
import DashboardFilterTags from "modules/dashboard/dashboard-filter-tags";
import RenameReportPopover from "blocks/rename-report-popover";
import { ModalName as AsAssistantModal } from "blocks/ai-assistant-popover";
import { RiChatVoiceAiFill } from "react-icons/ri";

/**
 * Style dependencies
 */
import "./styles.scss";

// new
import DashboardHeader from "modules/dashboard/dashboard-header";
import { createOpenModalAction } from "../../state/ui/actions";
import page from "page";
import { useActivePartnerProvider } from "../../data/active-partner-provider/hooks";

const Dashboard = (props) => {
  const { partner } = useActivePartnerProvider();

  const updateLayout = (layoutId, items) => {
    props.editLayout(items);
  };

  return (
    <React.Fragment>
      <DocumentHead title="Visual Deck" />
      <Box className="vd-dashboard__main-header-container">
        <DashboardHeader />
      </Box>

      <Main className="vd-dashboard__main">
        <Box
          marginBottom="xlarge"
          display="flex"
          justifyContent="spaceBetween"
          alignItems="center"
          width="full"
        >
          <Box display="flex" alignItems="center">
            {partner?.aiEnabled && (
              <div className="relative" onClick={() => page("/chat")}>
                <div className="ai-assistant__toggle bg-indigo-500 ">
                  <div className="absolute inset-0 w-[50px] h-[50px] animate-ping bg-black rounded-full opacity-20"></div>
                  <RiChatVoiceAiFill size={25} />
                </div>
              </div>
            )}
            <DashboardFilters />
            <Box marginLeft="large">
              <DashboardFilterTags />
            </Box>
          </Box>
          <DashboardActions />
        </Box>
        <Box>
          <Grid onLayoutChange={updateLayout} />
        </Box>
      </Main>
      <EditDashboardPopover />
      <RenameReportPopover />
    </React.Fragment>
  );
};

export default connect(null, {
  editLayout: updateLayoutItems,
  openAiAssistantModal: createOpenModalAction(AsAssistantModal),
})(Dashboard);
